const styles = (theme) => ({
  noteRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    '& .MuiFormControl-root': {
      flex: 1
    },
    '& button': {
      whiteSpace: 'nowrap',
      flexShrink: 0,
      // the note field reserves 16px above its input for the MUI floating label; match it so
      // the button and input line up
      marginTop: 16
    }
  },
  farmPolicyCard: {
    padding: theme.spacing(4),
    backgroundColor: theme.colorPalette.beige_40,
    boxShadow: 'none'
  },
  farmPolicyTitle: {
    color: theme.colorPalette.green_80,
    fontSize: 20,
    fontWeight: 400,
    marginBottom: theme.spacing(2)
  },
  farmPolicySubtitle: {
    marginBottom: theme.spacing(2),
    color: theme.colorPalette.green_80,
    fontSize: 16,
    fontWeight: 600
  },
  farmPolicyRadioGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  farmPolicyButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3)
  },
  cancelButton: {
    width: 85,
    backgroundColor: theme.colorPalette.orange_50,
    color: theme.colorPalette.white,
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_75
    }
  },
  savePolicyButton: {
    backgroundColor: theme.colorPalette.green_90,
    color: theme.colorPalette.white,
    '&:hover': {
      backgroundColor: theme.colorPalette.green_100
    }
  },
  notification: {
    minHeight: 30,
    boxShadow: 'none',
    '& img': {
      fontWeight: 400
    }
  }
});

export default styles;
